import { render, staticRenderFns } from "./ChangeStoreToNewPartialArea.vue?vue&type=template&id=2cf0eca0"
import script from "./ChangeStoreToNewPartialArea.vue?vue&type=script&lang=ts"
export * from "./ChangeStoreToNewPartialArea.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports